import { 
  SELECT_QUESTION_OPTION, 
  SUBMIT_QUESTION_ANSWER 
} from "../../Redux.constants";
import { 
  selectQuestionOption, 
  submitQuestionAnswer 
} from "./helper";

export function CSCQReducer(state={}, action) {
  switch (action.type) {
    case SELECT_QUESTION_OPTION:
      return selectQuestionOption(state, action.payload);
    case SUBMIT_QUESTION_ANSWER:
      return submitQuestionAnswer(state, action.payload);
    default:
      return state;
  }
}